import { Icon } from '@lambdacurry/component-library';

export const FooterDiamond = () => <Icon className="text-brand-green-500" name="diamond" />;
